import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "statistics-portal export-page" }
const _hoisted_2 = {
  key: 0,
  class: "statistics-portal__body container-page big export-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsPortalExportButtons = _resolveComponent("StatisticsPortalExportButtons")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_StatisticsPortalFilter = _resolveComponent("StatisticsPortalFilter")!
  const _component_StatisticsPortalVisitsCountTabs = _resolveComponent("StatisticsPortalVisitsCountTabs")!
  const _component_StatisticsPortalAverageVisitsTimeTabs = _resolveComponent("StatisticsPortalAverageVisitsTimeTabs")!
  const _component_StatisticsPortalViewsCountTabs = _resolveComponent("StatisticsPortalViewsCountTabs")!
  const _component_StatisticsPortalUniqueVisitsCountTab = _resolveComponent("StatisticsPortalUniqueVisitsCountTab")!
  const _component_StatisticsPortalEventsUsersTable = _resolveComponent("StatisticsPortalEventsUsersTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      dense: "",
      title: "Статистика посещений. Административная часть"
    }, _createSlots({ _: 2 }, [
      (_ctx.isAccessAllowed)
        ? {
            name: "button",
            fn: _withCtx(() => [
              _createVNode(_component_StatisticsPortalExportButtons, { filter: _ctx.filter }, null, 8, ["filter"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    (_ctx.isAccessAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_StatisticsPortalFilter, { onSearchFilter: _ctx.searchFilter }, null, 8, ["onSearchFilter"]),
          _createVNode(_component_StatisticsPortalVisitsCountTabs, { filter: _ctx.filter }, null, 8, ["filter"]),
          _createVNode(_component_StatisticsPortalAverageVisitsTimeTabs, { filter: _ctx.filter }, null, 8, ["filter"]),
          _createVNode(_component_StatisticsPortalViewsCountTabs, { filter: _ctx.filter }, null, 8, ["filter"]),
          _createVNode(_component_StatisticsPortalUniqueVisitsCountTab, { filter: _ctx.filter }, null, 8, ["filter"]),
          _createVNode(_component_StatisticsPortalEventsUsersTable, { class: "statistics-portal__events-users-table" })
        ]))
      : _createCommentVNode("", true)
  ]))
}